module.exports = __webpack_public_path__ + "static/media/11.b694f7e2.jpg";